import { formatNumber } from '@/config/function';

export const loadScore = (target) => {
    let money = window.$store.state.money;
    let unit_money = money ? money.unit : process.env.VUE_APP_DEFAULT_UNIT;
    target.$confirm(`Số ${unit_money} không đủ để thực hiện giao dịch, Bạn có muốn nạp ${unit_money} không?`, 'Cảnh báo', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
    }).then(res => {
        window.location.href = process.env.VUE_APP_URL_LOAD_SCORE;
    }).catch(() => {});
}

export const upTop = async (id, target) => {
    let config = window.$store.state.config;
    let money = window.$store.state.money;
    let unit_money = money ? money.unit : process.env.VUE_APP_DEFAULT_UNIT;
    let count = Array.isArray(id) ? id.length : 1;
    let price = config.con_raovat_up_price ? config.con_raovat_up_price.money : process.env.VUE_APP_RV_UP_PRICE;
    let unit = config.con_raovat_up_price ? config.con_raovat_up_price.unit : process.env.VUE_APP_RV_UP_UNIT;

    if(money.money < count*price){
        loadScore(target);
        return;
    }

    let message;
    if(count == 1){
        message = `Bạn có chắc chắn up tin này lên đầu? <br/> Phí:<b class="text-danger mx-1">${formatNumber(price)}</b>${unit_money}/${unit}`;
    }else{
        message = `Bạn có chắc chắn up ${formatNumber(count)} tin này lên đầu? <br/> Phí:<b class="text-danger mx-1">${formatNumber(count)} x ${formatNumber(price)} = ${formatNumber(count*price)}</b>${unit_money}`;
    }
    console.log('hello')
    target.$confirm(message, 'Up tin lên đầu', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'success'
    }).then(async res => {
        await apiPost('/v2/profile/raovat/up_top', {
            id: id,
            source_pay: Vue.prototype.$detect == 'web' ? 0 : 1,
        }).then(res => {
            if(res.success == 1) {
                target.$message({
                    message: 'Thao tác thành công',
                    type: 'success',
                    center: true,
                });
                getMoney();
            }else{
                target.$message({
                    message: res.message,
                    type: 'error',
                    center: true,
                });
            }
        })
    }).catch(() => {})
}

export const availability = async (id, target) => {
    let config = window.$store.state.config;
    let money = window.$store.state.money;
    let unit_money = money ? money.unit : process.env.VUE_APP_DEFAULT_UNIT;
    let count = Array.isArray(id) ? id.length : 1;
    let price = config.con_raovat_up_price ? config.con_raovat_up_price.money : process.env.VUE_APP_RV_UP_PRICE;
    let unit = config.con_raovat_up_price ? config.con_raovat_up_price.unit : process.env.VUE_APP_RV_UP_UNIT;
    let success = false;
    if(money.money < count*price){
        loadScore(target);
        return;
    }

    let message;
    if(count == 1){
        message = `Bạn có chắc chắn gia hạn tin này? <br/> Phí:<b class="text-danger mx-1">${formatNumber(price)}</b>${unit_money}/${unit}`;
    }else{
        message = `Bạn có chắc chắn gia hạn ${formatNumber(count)} tin này? <br/> Phí:<b class="text-danger mx-1">${formatNumber(count)} x ${formatNumber(price)} = ${formatNumber(count*price)}</b>${unit_money}`;
    }
    await target.$confirm(message, 'Gia hạn tin', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'success'
    }).then(async res => {
        await apiPost('/v2/profile/raovat/availability', {
            id: id,
            source_pay: Vue.prototype.$detect == 'web' ? 0 : 1,
        }).then(res => {
            if(res.success == 1) {
                target.$message({
                    message: 'Thao tác thành công',
                    type: 'success',
                    center: true,
                });
                getMoney();
                success = true;
            }else{
                target.$message({
                    message: res.message,
                    type: 'error',
                    center: true,
                });
            }
        })
    }).catch(() => {})
    return success;
}

export const destroy = async (id, target) => {
    await target.$confirm('Bạn có chắc chắn xóa tin rao vặt?', 'Xóa tin rao vặt', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'error'
    }).then(async res => {
        let returnID = '';
        if(!Array.isArray(id)){
            returnID = id;
        }else{
            id.map((item, index) => {
                if(index == 0){
                    returnID += item.toString();
                }else{
                    returnID += ','+item;
                }
            })
        }
        await apiDelete('/v2/raovat/'+returnID).then(res => {
            if(res.status == 204){
                target.$message({
                    message: 'Thao tác thành công',
                    type: 'success',
                    center: true,
                });
                target.$eventBus.$emit('call-rv-current-page', true)
            }else{
                target.$message({
                    message: res.data.message,
                    type: 'warning',
                    center: true,
                });
            }
        });
    }).catch(() => {})
}
